export default "__VITE_ASSET__df8fe28f__"